// =================================================================================
// src/pages/AdminPage.js
// **UPDATED** to handle data refreshing for the Customers tab.
// =================================================================================
import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Typography, AppBar, Toolbar, Button } from '@mui/material';
import { fetchCustomers } from '../services/apiClient';
import CalendarsTab from '../components/admin/CalendarsTab';
import HotTopicsTab from '../components/admin/HotTopicsTab';
import CustomersTab from '../components/admin/CustomersTab';
import FAQsTab from '../components/admin/FAQsTab';
import ChatLogsTab from '../components/admin/ChatLogsTab';
import TelusLogo from '../components/TelusLogo';
import { Logout } from '@mui/icons-material';

export default function AdminPage({ onLogout }) {
    const [tabIndex, setTabIndex] = useState(0);
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchData = async () => {
        setLoading(true);
        try {
            const customerData = await fetchCustomers();
            setCustomers(customerData);
            setError('');
        } catch (e) {
            setError(e.message || 'Failed to fetch customer list.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    return (
        <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: '100vh', flexDirection: 'column' }}>
            <AppBar position="static" color="default" elevation={1}>
                <Toolbar>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <TelusLogo />
                        <Typography variant="h6" component="div" sx={{ ml: 2, flexGrow: 1, fontWeight:'bold' }}>
                           RBS_CA Admin Portal
                        </Typography>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                        <Tabs value={tabIndex} onChange={handleTabChange} centered>
                            <Tab label="Calendars" />
                            <Tab label="Hot Topics" />
                            <Tab label="Customers" />
                            <Tab label="FAQs" /> 
                            <Tab label="Chat Logs" />
                        </Tabs>
                    </Box>
                     <Button 
                        variant="outlined" 
                        startIcon={<Logout />} 
                        onClick={onLogout}
                        sx={{ textTransform: 'none' }}
                    >
                        Logout
                    </Button>
                </Toolbar>
            </AppBar>

            <Box sx={{ p: 3, flexGrow: 1, overflowY: 'auto' }}>
                {tabIndex === 0 && <CalendarsTab customers={customers} loading={loading} error={error} />}
                {tabIndex === 1 && <HotTopicsTab customers={customers} loading={loading} error={error} />}
                {tabIndex === 2 && <CustomersTab customers={customers} onUpdate={fetchData} />}
                {tabIndex === 3 && <FAQsTab customers={customers} loading={loading} error={error} />}
                {tabIndex === 4 && <ChatLogsTab />}
            </Box>
        </Box>
    );
}

